export default __webpack_public_path__ + "static/media/se.ad440502.png";